export const GENERIC_ERROR_MESSAGE = "Ha ocurrido un error, intentelo nuevamente o contacte al soporte técnico.";
